import {
  ADMIN,
  COOKIE_DOWNTIME_NOTIFICATION_SHOWN,
  DOWNTIME_NOTIFICATION_MESSAGE,
  COOKIE_JWT,
  COOKIE_SAP,
  LINKS_KEY,
  TYPE_KEY
} from "../common/constant";
import { clearMessages, createErrorMessages, createWarningMessages, messagesReceived } from "./message";
import { MAINTENANCE_ENABLED } from "./maintenance";

import { Cookies } from "react-cookie";
import navigate from "../common/navigate";
import rest from "../common/rest";
import { getShowHint } from "../common/runtimeConfig";

const CLEAR_TOKEN_ACTION = "LOGIN_CLEAR_TOKEN_ACTION";
const LOGIN_SUCCESSFUL_ACTION = "LOGIN_LOGIN_SUCCESSFUL_ACTION";
const PASSWORD_CHANGED_ACTION = "LOGIN_PASSWORD_CHANGED_ACTION";
const USERNAME_CHANGED_ACTION = "LOGIN_USERNAME_CHANGED_ACTION";
const TOGGLE_SMALL_HEADER_ACTION = "TOGGLE_SMALL_HEADER_ACTION";
const SET_TOKEN = "LOGIN_SET_TOKEN";
const SET_NAMES = "SET_NAMES";
const SET_SAP_TOKEN = "LOGIN_SET_SAP_TOKEN";

export const IS_LOGGED_IN_KEY = "isLoggedIn";
export const USERNAME_KEY = "username";
export const USER = "user";
export const CURRENT_USERNAME = "currentUsername";
export const FIRSTNAME = "firstname";
export const LASTNAME = "lastname";
export const PASSWORD_KEY = "password";
export const TOKEN_KEY = "token";
export const LINKS_SURVEY_ENTRY = "surveyEntryHref";
export const LINKS_SURVEY_ADMIN_ENTRY = "surveyAdminEntryHref";
export const SMALL_HEADER_EXPANDED = "smallHeaderExpanded";
export const USER_ID = "userId";
export const ROLES = "role";
export const PARTICIPATIONS = "participations";
export const IS_ADMIN_USER = "adminUser";
export const SAP_TOKEN = "sap_token";
export const SHOW_HINT = "showHint";
export const SHOW_MESSAGE = "showMessage";
export const ALLOW_ADMIN_EDITING = "allowAdminEditing";

const initialState = {
  [IS_LOGGED_IN_KEY]: false,
  [USERNAME_KEY]: "",
  [PASSWORD_KEY]: "",
  [TOKEN_KEY]: "",
  [LINKS_KEY]: [],
  [SMALL_HEADER_EXPANDED]: false,
  [ROLES]: [],
  [PARTICIPATIONS]: [],
  [SAP_TOKEN]: "",
  [SHOW_HINT]: getShowHint(),
  [SHOW_MESSAGE]: false,
  [USER]: "",
  [CURRENT_USERNAME]: "",
  [FIRSTNAME]: "",
  [LASTNAME]: ""
};

const cookies = new Cookies();

export default function reducer(state = initialState, action) {
  let newState;

  switch (action[TYPE_KEY]) {
    case SET_TOKEN:
      newState = Object.assign({}, state, {
        [TOKEN_KEY]: action[TOKEN_KEY]
      });
      break;

    case SET_SAP_TOKEN:
      newState = Object.assign({}, state, {
        [SAP_TOKEN]: action[SAP_TOKEN]
      });
      break;

    case CLEAR_TOKEN_ACTION:
      newState = Object.assign({}, state, {
        [IS_LOGGED_IN_KEY]: false,
        [TOKEN_KEY]: "",
        [LINKS_KEY]: [],
        [USER_ID]: "",
        [SAP_TOKEN]: "",
        [SHOW_MESSAGE]: false,
        [CURRENT_USERNAME]: ""
      });
      break;

    case LOGIN_SUCCESSFUL_ACTION:
      newState = Object.assign({}, state, {
        [IS_LOGGED_IN_KEY]: action[IS_LOGGED_IN_KEY],
        [USERNAME_KEY]: "",
        [PASSWORD_KEY]: "",
        [TOKEN_KEY]: action[TOKEN_KEY],
        [LINKS_KEY]: action[LINKS_KEY],
        [LINKS_SURVEY_ENTRY]: action[LINKS_SURVEY_ENTRY],
        [LINKS_SURVEY_ADMIN_ENTRY]: action[LINKS_SURVEY_ADMIN_ENTRY],
        [USER_ID]: action[USER_ID],
        [ROLES]: action[ROLES],
        [PARTICIPATIONS]: action[PARTICIPATIONS],
        [USER]: action[USER],
        [CURRENT_USERNAME]: action[CURRENT_USERNAME],
        [FIRSTNAME]: action[FIRSTNAME],
        [LASTNAME]: action[LASTNAME],
        [IS_ADMIN_USER]: action[ROLES].includes(ADMIN),
        [SHOW_HINT]: action[SHOW_HINT],
        [SHOW_MESSAGE]: action[SHOW_MESSAGE],
        [ALLOW_ADMIN_EDITING]: action[ALLOW_ADMIN_EDITING]
      });
      break;

    case PASSWORD_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [PASSWORD_KEY]: action[PASSWORD_KEY]
      });
      break;

    case USERNAME_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [USERNAME_KEY]: action[USERNAME_KEY]
      });
      break;

    case SET_NAMES:
      newState = Object.assign({}, state, {
        [FIRSTNAME]: action[FIRSTNAME],
        [LASTNAME]: action[LASTNAME]
      });
      break;
    case TOGGLE_SMALL_HEADER_ACTION:
      newState = Object.assign({}, state, {
        [SMALL_HEADER_EXPANDED]: action[SMALL_HEADER_EXPANDED]
      });
      break;

    default:
      newState = Object.assign({}, state, {});
      break;
  }

  rest.token = newState[TOKEN_KEY];
  return newState;
}

//async actions
export function doLogin(jwt, sap_token, redirectOnFail) {

  return (dispatch, getState) => {
    if (getState().maintenance && getState().maintenance[MAINTENANCE_ENABLED]) {
      dispatch(messagesReceived(createWarningMessages("maintenance.login.disabled")));
      return;
    }

    let login;

    // If no token is not supplied get credential
    if (typeof jwt === "string") {
      if (typeof sap_token === "string") {
        dispatch(setSapToken(sap_token));
      }

      dispatch(setToken(jwt));

      login = rest.doGet(`/authentication/token`);
    } else {
      login = rest.doLogin(`/authentication/token`, getState().login.username.trim(), getState().login.password);
    }

    login.then(
      (result) => {
        if (result && result.token) {
          dispatch(setToken(result.token));
          // Set cookies
          setCookie(COOKIE_JWT, result.token);

          if (typeof sap_token === "string") {
            setCookie(COOKIE_SAP, sap_token);
          }

          // get client configuration
          const showHint = getShowHint();
          let allowAdminEditing = false;
          let showMessage = false;

          // Get user role
          rest.doGet(`/admin/clientConfig`).then((clientConfig) => {
            allowAdminEditing = clientConfig.allowAdminEditing;
            showMessage = clientConfig.showMessage;

            rest.doGet(`/authentication/users/current`).then(
              (currentUser) => {

                let roles = currentUser.roles.map((x) => x.name);

                // resolve permissions from roles
                currentUser.roles &&
                    currentUser.roles.forEach((r) =>
                        r.permissions.forEach((permission) => {
                            if (!roles.includes(permission.name)) {
                            roles.push(permission.name);
                            }
                        })
                    );

                const finalizeLogin = (participations = null) => {
                    dispatch(
                        loginSuccessful(
                            result.token,
                            result.links,
                            currentUser.identifier,
                            roles,
                            currentUser.firstname,
                            currentUser.lastname,
                            currentUser.username || currentUser.email || "",
                            showHint,
                            showMessage,
                            allowAdminEditing,
                            participations
                        )
                    );

                    dispatch(clearMessages());

                    if (showMessage && shouldShowDowntimeNotificationToday()) {
                        dispatch(
                        messagesReceived(
                            createWarningMessages(DOWNTIME_NOTIFICATION_MESSAGE)
                        )
                        );
                    }
                };

                // Only fetch /admin/users/myuser if currentUser.active is true
                if (currentUser.active) {
                    //rest.doGet(`/admin/users/myuser`).then((user) => {
                    //    finalizeLogin(user.participations);
                    //});
                    finalizeLogin();
                } else {
                    finalizeLogin();
                }


              },
              (reason) => {
                dispatch(messagesReceived(createErrorMessages(`login.error.${reason.status}`)));
                dispatch(clearToken());
              }
            );
          });

          let redirect = new URL(window.location.href).searchParams.get("redirect");
          if (redirect) {
            if (redirect.startsWith("http")) {
              redirect = new URL(redirect);
              redirect = redirect.pathname + redirect.search + redirect.hash;
            } else if (!redirect.startsWith("/")) {
              redirect = "/" + redirect;
            }
            navigate.to(redirect);
          }
        } else {
          dispatch(messagesReceived(createErrorMessages(result)));
          dispatch(clearToken());
        }
      },
      (reason) => {
        rest.token = false;
        let encryptedUser = btoa(getState().login.username);
        rest.doGet(`/authentication/public/blockedUser?username=` + encryptedUser).then(
          (currentUser) => {
            if (currentUser) {
              dispatch(messagesReceived(createErrorMessages(`login.error.blocked`)));
            }
          },
          (reason2) => {
            dispatch(messagesReceived(createErrorMessages(`login.error.${reason2.status}`)));
            dispatch(clearToken());
          }
        );
        dispatch(messagesReceived(createErrorMessages(`login.error.${reason.status}`)));
        dispatch(clearToken());
      }
    );
  };
}

//sync actions
export function loginSuccessful(
  token,
  links,
  userid,
  role,
  firstName,
  lastName,
  currentUsername,
  showHint,
  showMessage,
  allowAdminEditing,
  participations
) {
  const adminSurvey = `/admin/admin/surveys`;
  const survey = `/survey/surveys`;
  return {
    [TYPE_KEY]: LOGIN_SUCCESSFUL_ACTION,
    [IS_LOGGED_IN_KEY]: true,
    [TOKEN_KEY]: token,
    [LINKS_KEY]: links,
    [LINKS_SURVEY_ADMIN_ENTRY]: adminSurvey,
    [LINKS_SURVEY_ENTRY]: survey,
    [USER_ID]: userid,
    [ROLES]: role,
    [PARTICIPATIONS]: participations,
    [USER]: firstName + " " + lastName,
    [CURRENT_USERNAME]: currentUsername,
    [FIRSTNAME]: firstName,
    [LASTNAME]: lastName,
    [SHOW_HINT]: showHint,
    [SHOW_MESSAGE]: showMessage,
    [ALLOW_ADMIN_EDITING]: allowAdminEditing
  };
}

export function usernameChanged(username) {
  return {
    [TYPE_KEY]: USERNAME_CHANGED_ACTION,
    [USERNAME_KEY]: username
  };
}

export function namesChanged(firstname, lastname) {
  return {
    [TYPE_KEY]: SET_NAMES,
    [FIRSTNAME]: firstname,
    [LASTNAME]: lastname
  };
}

export function passwordChanged(password) {
  return {
    [TYPE_KEY]: PASSWORD_CHANGED_ACTION,
    [PASSWORD_KEY]: password
  };
}

export function clearToken() {
  return {
    [TYPE_KEY]: CLEAR_TOKEN_ACTION
  };
}

export function toggleSmallHeaderAction(toggleHeader) {
  return {
    [TYPE_KEY]: TOGGLE_SMALL_HEADER_ACTION,
    [SMALL_HEADER_EXPANDED]: toggleHeader
  };
}

function setCookie(name, jwt) {
  let cookieConfig = {
    path: "/",
    maxAge: 7200
  };
  cookies.set(name, jwt, cookieConfig);
}

function shouldShowDowntimeNotificationToday() {
  return cookies.get(COOKIE_DOWNTIME_NOTIFICATION_SHOWN) !== getDateKey(new Date());
}

function getDateKey(date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

function setToken(jwt) {
  return {
    [TYPE_KEY]: SET_TOKEN,
    [TOKEN_KEY]: jwt
  };
}

function setSapToken(sap_token) {
  return {
    [TYPE_KEY]: SET_SAP_TOKEN,
    [SAP_TOKEN]: sap_token
  };
}
